var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2898 15.8885C19.1663 10.855 14.1449 6.49761 7.892 5.13512C5.84544 4.8316 7.22903 3.33603 10.0601 2.2323C14.4765 0.808372 21.2739 8.75158 24.2898 15.8885Z",
    fill: "#3E3E7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2185 16.6517L17.9188 18.3958C8.71366 17.3056 -5.39895 11.3596 2.13576 5.76596C4.22399 4.21461 7.47107 2.97417 10.06 2.2323C9.77612 2.36565 9.49263 2.49308 9.21303 2.68678C8.22289 3.37421 7.8082 4.20049 7.89194 5.13512C8.21899 8.79904 15.7497 13.8851 22.2185 16.6517Z",
    fill: "#51518E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3741 15.7727C27.2771 10.7478 30.2465 6.27129 34.8211 3.86099C36.3491 3.18297 34.5543 2.20694 32.5065 2.06862C28.7604 1.91309 25.1822 9.56488 24.3741 15.7727Z",
    fill: "#3E3E7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1514 15.9199L29.8756 16.35C36.8077 13.5147 46.5129 5.83924 39.439 3.10995C37.4782 2.35276 34.6823 2.08754 32.5063 2.06873C32.7588 2.0901 33.0236 2.13096 33.2832 2.22156C34.2025 2.5431 34.6844 3.11533 34.8209 3.8611C35.3571 6.78435 30.5912 12.3697 26.1514 15.9199Z",
    fill: "#51518E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7019 51.2739C11.1754 50.4513 8.96406 49.5308 7.17545 48.4821C6.99438 44.0495 6.80956 38.1586 4.37048 34.526C4.84593 32.5356 6.53144 30.5431 8.99928 28.8677C10.1792 29.4539 15.2948 45.2724 13.7019 51.2739Z",
    fill: "#8888E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1997 53.7145C20.851 53.224 18.6153 52.6981 16.538 52.1237C14.2853 40.0709 13.0075 30.8106 13.0075 26.4654C14.8888 25.437 16.8935 24.4285 18.8395 23.4102C23.1271 26.099 25.3256 45.0162 23.1997 53.7145Z",
    fill: "#8888E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0082 51.274C38.9336 41.4087 38.6564 31.5434 38.5385 21.6771C40.3019 20.7213 43.5375 19.9642 47.2754 21.9214C46.3971 28.8676 47.6954 44.8422 48.5986 48.1551C47.661 49.1352 44.1565 50.2768 40.0082 51.274Z",
    fill: "#A4A4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.709 52.5922C29.0851 53.4299 24.7964 53.9296 23.1996 53.7147C23.3105 43.3736 22.4255 34.9149 19.3309 25.0464C20.0758 24.2288 24.266 20.0219 30.8817 21.5642C34.7913 31.5475 36.1752 42.2309 33.709 52.5922Z",
    fill: "#A4A4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39188 30.0638C7.26574 31.5958 5.3665 33.3482 3.68705 35.2922C2.17158 34.1226 1.09998 31.5944 0.961792 29.2967C2.72607 27.066 4.69937 25.0091 6.9895 23.162C8.96697 24.4277 10.5546 28.134 9.39188 30.0638Z",
    fill: "#A4A4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3308 25.0463C17.193 25.7589 15.1864 26.6169 13.3121 27.6201C12.5172 27.6288 10.1912 22.4629 11.1673 20.2519C12.9931 19.1588 14.9946 18.1736 17.2041 17.3057C19.7062 26.414 19.2832 24.8639 19.3308 25.0463Z",
    fill: "#A4A4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0565 22.314C27.1311 22.8651 23.222 23.7655 19.331 25.0462L19.3199 25.0059L18.8798 23.4051L17.2042 17.3056C21.1084 15.6705 25.0054 14.6743 28.9126 14.1364C30.6123 15.925 32.8894 20.5517 31.0565 22.314Z",
    fill: "#C5C5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7978 14.5804C50.6979 17.3057 50.1762 20.6986 49.0347 22.092C48.4482 22.0284 47.8619 21.9718 47.2754 21.9214C44.3545 21.6711 41.4414 21.5843 38.5386 21.6772C36.6096 21.3862 35.8576 15.9975 37.2617 13.6187C41.4112 13.6418 45.5837 14.0333 49.7978 14.5804Z",
    fill: "#C5C5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.538 52.1239C15.5548 51.8523 14.6081 51.5687 13.7017 51.2741C13.526 44.9374 11.8627 37.6924 9.39186 30.0639C9.26363 29.6661 9.13243 29.2674 8.99922 28.8678C8.37349 26.9844 7.70017 25.0808 6.98962 23.162C8.2755 22.1234 9.66232 21.1515 11.1673 20.2521C11.8395 22.3374 12.4532 24.4085 13.0073 26.4656C13.1112 26.8511 13.2121 27.2357 13.3121 27.6202C15.4943 36.0541 16.6429 44.2399 16.538 52.1239Z",
    fill: "#2C2C61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0081 51.274C37.9874 51.7604 35.8134 52.2117 33.7089 52.5922C34.4306 43.0358 33.4839 32.8889 31.0564 22.3141C30.9998 22.0648 30.9413 21.8145 30.8817 21.5642C30.3044 19.1105 29.6463 16.6336 28.9125 14.1365C31.6892 13.7539 34.4709 13.6026 37.2618 13.6187C37.6978 16.0149 38.0834 18.41 38.4185 20.8062C38.4599 21.097 38.5002 21.3866 38.5386 21.6773C39.8729 31.5435 40.3625 41.4088 40.0081 51.274Z",
    fill: "#3E3E7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6426 51.3929C57.5939 58.2322 50.3903 61.6667 44.5537 59.0656C42.9514 58.3519 41.6193 57.2563 40.5937 55.9014C53.5882 48.9854 55.5884 41.1782 51.467 33.4302C52.8717 33.4288 54.2697 33.7084 55.5964 34.2999C61.4317 36.9009 63.6913 44.5549 60.6426 51.3929Z",
    fill: "#F6C719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.371 50.3094C54.3102 56.8894 46.2624 61.6519 40.5939 55.9014C37.8786 52.3217 37.2965 46.9314 39.5077 41.9713C41.8641 36.6872 46.6993 33.4356 51.4672 33.4302C58.2259 34.7865 60.2933 44.032 57.371 50.3094Z",
    fill: "#F6D14F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3561 48.6289C55.4485 43.9351 54.4509 38.9292 51.1279 37.4479C47.8049 35.9665 43.4149 38.5707 41.3225 43.2645C39.2301 47.9583 40.2277 52.9642 43.5507 54.4455C46.8736 55.9268 51.2637 53.3226 53.3561 48.6289Z",
    fill: "#F6C719"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_131_426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0013 52.2153C40.7583 57.2471 35.4586 59.7739 31.1645 57.8603C29.9857 57.3351 29.0057 56.5291 28.2511 55.5323C37.8113 50.4441 39.2828 44.7003 36.2507 39C37.2842 38.999 38.3127 39.2047 39.2888 39.6399C43.5818 41.5535 45.2442 47.1846 43.0013 52.2153Z",
    fill: "#F6C719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5943 51.4182C38.3425 56.2592 32.4217 59.763 28.2513 55.5323C26.2536 52.8987 25.8254 48.933 27.4522 45.2838C29.1858 41.3962 32.7431 39.004 36.2509 39C41.2233 39.9979 42.7443 46.7998 40.5943 51.4182Z",
    fill: "#F6D14F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6406 50.1818C39.18 46.7285 38.446 43.0456 36.0013 41.9558C33.5565 40.866 30.3267 42.7819 28.7873 46.2351C27.2479 49.6884 27.9819 53.3713 30.4266 54.4611C32.8714 55.5509 36.1012 53.635 37.6406 50.1818Z",
    fill: "#F6C719"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_131_426",
    x: 22.4539,
    y: 39,
    width: 25.5461,
    height: 27.4996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.383333 0 0 0 0 0.292409 0 0 0 0 0.00479167 0 0 0 0.68 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "color-burn",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_131_426"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_131_426",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftbox);
export default __webpack_public_path__ + "static/media/giftbox.8a6a453344f1daf7a89d9a17761ad3b7.svg";
export { ForwardRef as ReactComponent };